import React from 'react';
import { Layout, Card, Row, Col, Statistic, Select, Typography, Tooltip } from 'antd';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import checkIcon from "../../assets/images/check.svg";
import { Link } from 'react-router-dom';

const { Title, Paragraph } = Typography;

const MenuItemCard = ({ menuItem }) => {
  return (
    <div className='ant-card-bordered menu-card site-layout-background mb-8 block'>
      <Row gutter={[16, 48]} className="space-between">
        <Col md={6}>
          <img src={menuItem.photo_url} alt={menuItem.name} className="h-full" />
        </Col>
        <Col md={10} className="py-24">
          <div className='text-left'>
            <Title level={3}>{menuItem.name}</Title>
            <Paragraph>{menuItem.description}</Paragraph>
          </div>
        </Col>
        <Col md={4} className="py-24">
            <div className='flex items-center mb-8'>
              <span className={`check-icon-container mr-8 ${menuItem.is_vegan ? 'bg-theme' : 'icon-inactive'}`}>
                <img src={checkIcon} alt="check" className='h-full'/>
              </span>
              Vegan
            </div>
            <div className='flex items-center mb-8'>
              <span className={`check-icon-container mr-8 ${menuItem.is_vegetarian ? 'bg-theme' : 'icon-inactive'}`}>
                <img src={checkIcon} alt="check" className='h-full'/>
              </span>
              Vegetarian
            </div>
            <div className='flex items-center mb-8'>
              <span className={`check-icon-container mr-8 ${menuItem.is_gluten_free ? 'bg-theme' : 'icon-inactive'}`}>
                <img src={checkIcon} alt="check" className='h-full'/>
              </span>
              Gluten Free
            </div>
        </Col>
        <Col md={4} className="py-24 pr-24 text-right">
          <div className="flex dir-col space-between h-full">
            <div className='cursor-pointer'>
              <Link to={`/menus/${menuItem.menu_id}/menu-items/edit/${menuItem.id}`}>
                <EditOutlined style={{ fontSize: 28, marginRight: 24 }} />
              </Link>
              <span className='color-theme'>
                <DeleteOutlined  style={{ fontSize: 28}} />
              </span>
            </div>
            <Title level={3}>
              ${menuItem.price}
            </Title>
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default MenuItemCard;
